import BenefitsSection from '@/v2/components/sections/common/benefits-section'
import FaqSection from '@/v2/components/sections/common/faq-section'
import ForWhoSection from '@/v2/components/sections/common/for-who-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import KeyFactorsSection from '@/v2/components/sections/common/key-factors-section'
import PartnersSection from '@/v2/components/sections/common/partners-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  benefitsSectionSectionContent,
  faqSectionContent,
  forWhoSectionContent,
  heroSectionContent,
  keyFactorsSectionContent,
  partnersSectionContent,
  promotionalBannerSectionContent,
  serviceTipsSectionSectionContent,
  whyChooseUsSectionContent
} from '@/v2/constants/pages/public-pages/domestic-shipping-services-page'

interface DomesticShippingServicesPageProps {}

const DomesticShippingServicesPage: React.FC<DomesticShippingServicesPageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
        w-[350px] h-[297px] 
        md-mn:w-[315px] md-mn:h-[177px] 
        lg:!w-[527px] lg:!h-[297px] 
        xl-min:!w-[680px] xl-min:!h-[458px]
      '
        btnClassName='xl-min:!w-[323px] lg-mn:w-[277px] xl-min:h-[50px] md-mn:w-[276px] w-[278px] h-[44px]'
        className='md-mn:[&>div:first-child]:max-w-[682px]'
      />
      <WhyWeSection
        {...whyChooseUsSectionContent}
        isBgDark
        className={`
          lg-mn:[&>div>div:nth-of-type(2)]:grid-cols-2
          xl-min:[&>div>div:nth-of-type(2)]:!grid-cols-4
          lg-mn:[&_article_p]:w-[80%]
          xl-min:[&_article_p]:!w-full
          xl-min:[&_button]:!w-[272px]
          lg-mn:[&_button]:w-[282px]
          md-mn:[&_button]:w-[246px]
          [&_button]:w-[250px]
          `}
      />
      <ServiceTipsSectionSection
        {...serviceTipsSectionSectionContent}
        sectionTitleClassName='xl-min:!w-[745px] md-mn:w-[551px] xl-min:[&_p]:!w-[80%] [&_p]:text-pretty [&_p]:w-[90%]'
        className='lg-mn:[&>div>div:nth-of-type(2)]:grid-cols-2 xl-min:[&>div>div:nth-of-type(2)]:!grid-cols-3'
      />
      <BenefitsSection {...benefitsSectionSectionContent} isBgDark />
      <PartnersSection {...partnersSectionContent} />
      <KeyFactorsSection {...keyFactorsSectionContent} isBgDark />
      <ForWhoSection {...forWhoSectionContent} />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        className='pt-0 xl-min:[&_p]:!w-[85%] md-mn:[&_p]:w-[98%]'
      />
      <FaqSection {...faqSectionContent} isBgDark />
    </>
  )
}

export default DomesticShippingServicesPage
